exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sale-in-logs-action__create{padding:4px 16px;color:#016088;background-color:#D9F4FD;border-radius:2px}.sale-in-logs-action__edit{padding:4px 16px;color:#3D3D3D;background-color:#DCDCDC;border-radius:2px}.sale-in-logs-action__import{padding:4px 16px;color:#FF9B1A;background-color:#FFF2DF;border-radius:2px}.history-logs-tabs .el-tabs__header{padding-left:24px}\n", ""]);

// exports
